import React, { useEffect, useState } from 'react';
import { Row, Col, InputGroup } from 'react-bootstrap';

import BitsyApollo from '../../services/BitsyApollo';
import BBAnalytics from '../../services/BBAnalytics';

import './style.scss';

export default function ShippingInsurance(props) {
  const [shippingInsurance, setShippingInsurance] = useState({});
  const [hasSubscription, setHasSubscription] = useState(false);

  useEffect(() => {
    const addOrRemoveShippingInsurance = () => {
      const { cartId, isShippingInsuranceSelected } = props;
      const dataObj = {
        cartId,
        isAddingInsurance: isShippingInsuranceSelected,
      };
      BitsyApollo.addOrRemoveShippingInsuranceForCart(dataObj).then(
        async (res) => {
          if (res && res.shippingInsurance && res.shippingInsurance.cost) {
            setShippingInsurance(res.shippingInsurance);
          }
          const setState = true;
          const cart = await props.getAndSetCart(setState);
          await BBAnalytics.updatedCartEvent(cart);
        },
      );
    };

    const setSubscriptionInfo = () => {
      const hasSub = !!props.subscription;
      setHasSubscription(hasSub, props.subscription);
    };

    addOrRemoveShippingInsurance();
    setSubscriptionInfo();
    // eslint-disable-next-line
  }, [props.isShippingInsuranceSelected]);

  return (
    <Row className='shipping-insurance-container'>
      <Col className='shippingInsuranceInputCol' xs={1} sm={1} md={1} lg={1}>
        <InputGroup.Prepend>
          <InputGroup.Checkbox
            checked={props.isShippingInsuranceSelected}
            onChange={props.onShippingInsuranceChange}
            name='isShippingInsuranceSelected'
            aria-label={`Add shipping insurance for ${shippingInsurance.cost}`}
            aria-describedby='shippingInsuranceTitleCol'
          />
        </InputGroup.Prepend>
      </Col>

      <Col xs={10} sm={10} md={11} lg={11}>
        <p className='bold shippingInsuranceTitle'>
          Yes, I would like to protect my{' '}
          {hasSubscription ? 'subscription' : 'purchase'} with Shipping
          Insurance for just ${shippingInsurance.cost}
          {hasSubscription ? ' with each box' : ''}.
        </p>
      </Col>
    </Row>
  );
}
